import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export const DesktopNav = () => {
    const navigate = useNavigate();

    const logoClick = () => {
        navigate("/")
    }


    return (
        <nav>
            <div className='nav'>
                <img onClick={logoClick} src='images/logo-head-2.png' width='100px' alt='alpha builders logo' />
                <ul className="nav-links">
                    <li><Link className='nav-link-style' style={{ textDecoration: 'none' }} to='/'>HOME</Link></li>
                    <li><Link className='nav-link-style' style={{ textDecoration: 'none' }} to='/about'>ABOUT</Link></li>
                    <li><Link className='nav-link-style' style={{ textDecoration: 'none' }} to='/portfolio'>PORTFOLIO</Link></li>
                    <li><Link className='nav-link-style' style={{ textDecoration: 'none' }} to='/services'>SERVICES</Link></li>
                </ul>

                <Link style={{ textDecoration: 'none' }} to='/contact' >
                    {/* <button className="header-button brass-gradient-wshimmer">Contact</button> */}
                    <button className=' header-button'>CONTACT</button>
                </Link>



            </div>



        </nav>
    )
}
